import { useEffect } from 'react'
import { ILayout, useLayout } from '../../core'
import { APP_VERSION } from '../../../../app/constants/version'

const Footer = () => {
  const { config } = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])

  const lastUpdate = import.meta.env.VITE_APP_GIT_DATE || 'unknown'

  return (
    <>
      <div className='text-gray-900 order-2 order-md-1'>
        <span className='text-muted fw-semibold me-1'>
          &copy; {new Date().getFullYear()} JOSTech POS System. All rights reserved.
        </span>
      </div>

      <div className='text-gray-900 order-1 d-flex align-items-center gap-3'>
        <span className='badge badge-light-primary fw-bold px-3 py-2 fs-8' title="App Version">
          v{APP_VERSION}
        </span>
        <span className='text-muted fs-7 fw-semibold'>
          Latest Update: {lastUpdate}
        </span>
      </div>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export { Footer }
